import type { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import i18n from "i18next";
import k from "src/i18n/keys";
import { Flex } from "@unifize/sarah";

import { fetchForm } from "src/actions/forms";
import InlineIcon from "src/components/Icon";
import * as colors from "src/styles/constants/colors";
import { iconSize } from "src/styles/constants/size";
import { IconContainer } from "src/components/Manage/Workflow/Templates/Table/Row/styles";
import { New } from "./styles";
import { LinkIconWrapper } from "./styles";
import * as status from "src/constants/status";
import type { FormsById } from "src/types";
import { Nullable } from "src/ts-types";
import { FormDeletionModalSetter } from "../types";

interface CellRendererParams extends CustomCellRendererProps {
  data: { id: number };
  formsById: FormsById;
  setFormDeletionModal: FormDeletionModalSetter;
}

export const TitleCellRenderer = ({
  data,
  formsById,
  setFormDeletionModal,
}: CellRendererParams): Nullable<React.ReactElement> => {
  const dispatch = useDispatch();
  const form = formsById[data.id];

  if (!form) return null;

  const handleEdit = () => {
    dispatch(fetchForm(form.id));
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setFormDeletionModal({ isOpen: true, formId: form.id });
  };

  const createdAtMoment =
    typeof form.createdAt === "string"
      ? moment(form.createdAt)
      : moment.unix(Number(form.createdAt));

  const isNew =
    moment().startOf("day").diff(createdAtMoment.startOf("day"), "days") === 0;

  return (
    <Flex items="center" height="100%">
      <LinkIconWrapper>
        <span key={form.id}>{form.title}</span>
        <IconContainer>
          <InlineIcon
            icon="edit"
            onClick={handleEdit}
            size={iconSize.space_m}
            color={colors.primary}
          />
        </IconContainer>
        <IconContainer>
          <InlineIcon
            icon="remove"
            onClick={handleDelete}
            size={iconSize.space_m}
          />
        </IconContainer>
        {isNew && <New status={status.NEW}> {i18n.t(k.NEW)}</New>}
      </LinkIconWrapper>
    </Flex>
  );
};
